import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

/**
 *
 * @param {*} params
 * @returns {Promise<FetchBusinessUnitResponse>}
 */
export function requestBusinessUnit(params) {
  return fetch.get(`${BASE_URL}/api/app/business-unit`, {
    params: { limit: 10000 },
  });
}

export function requestCreateBusinessUnit(value) {
  console.log(value);
  const data = { ...value };
  delete data["_id"];
  return fetch.post(
    `${BASE_URL}/api/app/business-unit/${data.businessCenter}/add/`,
    data
  );
}